import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase-config/firebase";
import { auth } from '../firebase-config/firebase'

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);




const Show = () => {
    
    // Configuracion de los hooks
    const [adultosm, setAdultosm] = useState([])
    const [search, setSearch] = useState("")
    
    //Referencia a firestore
    const adultosmCollection = collection(db, "adultosm")

    //Mostrar todos los datos
    const getAdultosm = async () => {
        const data = await getDocs(adultosmCollection);

        setAdultosm(

            data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))

        )
        //console.log(adultosm);
    }
    const searcher = (e) => {
        setSearch(e.target.value) 
    }

    let results = []
    if (!search){
        results = adultosm
    }else {
        results = adultosm.filter( (dato) =>
        dato.nombre.toLowerCase().includes(search.toLocaleLowerCase()))
    }
    


    //Usamos useEffect
    useEffect(() => {
        getAdultosm()
        // eslint-disable-next-line
    }, [])
    if (auth.currentUser === null) {
        return;
    }

    //Eliminar un campo persona

    const deleteAdultom = async (id) => {
        const adultoDoc = doc(db, "adultosm", id)
        await deleteDoc(adultoDoc)
        getAdultosm()

    }

    const confirmDelete = (id) => {
        MySwal.fire({
            title: "Eliminar Usuario",
            text: "Deseas eliminar este usuario?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, Eliminar"
        }).then((result) => {
            if (result.isConfirmed) {
                deleteAdultom(id)
                Swal.fire({
                    title: "Listo",
                    text: "Usuario eliminado",
                    icon: "success"
                });
            }
        });
    }

    //
    return (
        <>

            <div className="container">
                <div className='Header'>
                    <div className="row"> <h1>Registro de Adultos</h1> </div>
                    <div className='underlineC'></div>    
                </div>
                
                <div className="row">

                    <div className="col">

                        <div className="row">

                            <input className="cornerSearch" value={search} onChange={searcher} placeholder="Buscar nombre del adulto" type="text"></input>                           

                        </div>

                        <table className="table table-dark table-hover tshadow">
                            <thead>

                                <tr>
                                    <th>Nombre</th>
                                    <th>Apellidos</th>
                                    <th>Cedula</th>
                                    <th>Funciones</th>
                                </tr>

                            </thead>
                            <tbody>
                                {results.map((adulto) => (
                                    <tr key={adulto.id}>
                                        <td>{adulto.nombre}</td>
                                        <td>{adulto.apellidos}</td>
                                        <td>{adulto.cedula}</td>
                                        
                                        
                                        <td>
                                                                             
                                            <Link to={`/home/showAdult/${adulto.id}`} className="btn btn-light m-1"><i class="fa-solid fa-magnifying-glass"></i></Link>
                                            <button onClick={() => { confirmDelete(adulto.id) }} className="btn btn-danger m-1" ><i className="fa-solid fa-trash-can"></i></button>
                                        </td>
                                    </tr>

                                ))}
                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </>

    );

}
export default Show;
